export default __webpack_public_path__ + "static/media/scratch-resistant.005dc41c.svg";